import { saveAppointments } from '@ax/service';
import { SaveAppointmentsInput } from '@ax/service/src/appointment-interface';
import { useMutation } from '@tanstack/react-query';

export function useSaveAppointmentsApi() {
  const saveAppointmentsMutation = useMutation({
    mutationKey: ['save-appointments'],
    mutationFn: (data: SaveAppointmentsInput[]) => saveAppointments(data),
    onError: (error: any) => {
      return error;
    },
  });

  return saveAppointmentsMutation;
}
